/**
 * Configuración regional única de la plataforma: español de Chile y zona de Chile
 * continental (criterios 26.1 a 26.3).
 *
 * Están aquí, y no en el SPA, porque las necesitan los dos lados por motivos distintos y
 * tienen que ser el mismo valor. El SPA las usa para presentar fechas y horas; el cálculo
 * puro las usa para derivar la fecha civil de un instante UTC, que es lo que permite
 * agrupar por día sin desplazar los registros de la madrugada. Chile aplica horario de
 * verano, así que el desplazamiento no es una constante y la zona no se puede sustituir por
 * un desfase fijo.
 *
 * Ninguna de las dos se lee del entorno: la plataforma es de un solo país y una constante
 * verificable vale más que una variable que nadie configura.
 */

/** Etiqueta de idioma que reciben `Intl` y la cabecera `Accept-Language`. */
export const IDIOMA_CHILE = 'es-CL';

/**
 * Zona horaria canónica de la plataforma. Es la que convierte instante UTC en fecha civil,
 * y la única admitida en las conversiones del paquete compartido.
 */
export const ZONA_HORARIA_CHILE = 'America/Santiago';
